define('OutSystems/ClientRuntime/modules/Database/WebSQL/WebSQLEntityService',["require", "exports", "tslib", "../../../Exceptions", "../Common/EntityService", "./Upgrader/WebSQLMetadataV2Upgrader", "./Upgrader/WebSQLMetadataV2UpgraderStep2", "./WebSQLSerializer"], function (require, exports, tslib_1, Exceptions_1, EntityService_1, WebSQLMetadataV2Upgrader_1, WebSQLMetadataV2UpgraderStep2_1, WebSQLSerializer_1) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    var WebSQLEntityService = (function (_super) {
        tslib_1.__extends(WebSQLEntityService, _super);
        function WebSQLEntityService() {
            var _this = _super.call(this, new WebSQLSerializer_1.default()) || this;
            _this.isMetadataV2UpgraderRegistered = false;
            return _this;
        }
        WebSQLEntityService.prototype.registerInitializer = function (entityInfos) {
            if (!this.isMetadataV2UpgraderRegistered) {
                this.database.registerInitializer(WebSQLMetadataV2Upgrader_1.default);
                this.isMetadataV2UpgraderRegistered = true;
            }
            _super.prototype.registerInitializer.call(this, entityInfos);
            this.database.registerInitializer(new WebSQLMetadataV2UpgraderStep2_1.default());
        };
        WebSQLEntityService.prototype.executeAggregate = function (body) {
            return tslib_1.__awaiter(this, void 0, void 0, function () {
                var database, error_1;
                return tslib_1.__generator(this, function (_a) {
                    switch (_a.label) {
                        case 0: return [4, this.getDatabase()];
                        case 1:
                            database = _a.sent();
                            _a.label = 2;
                        case 2:
                            _a.trys.push([2, 4, , 5]);
                            return [4, database.executeQuery(body)];
                        case 3: return [2, _a.sent()];
                        case 4:
                            error_1 = _a.sent();
                            throw new Exceptions_1.Exceptions.DataBaseException("", error_1.message, error_1.stack);
                        case 5: return [2];
                    }
                });
            });
        };
        return WebSQLEntityService;
    }(EntityService_1.default));
    exports.default = WebSQLEntityService;
});
//# sourceMappingURL=WebSQLEntityService.js.map;
